const ENPHASE_INSTALLER = 'enphase_installer'
const ToggleOptions = [
  {
    id: 'enphase_installer',
    label: 'Enphase Installer',
  },
]

export { ToggleOptions, ENPHASE_INSTALLER }
 